import React, { useState, useRef, useEffect } from 'react';
import { CueTip } from '../../../components/Common/CueTooltip';
import FormHelper from '../../../components/FormBuilder/FormHelpers';
import { FieldLabel, Description, RequiredMsg, FieldPoint } from '../FieldLabel';

//https://css-tricks.com/value-bubbles-for-range-inputs/

const InputSlider = ({renderField, field, position, formData, modelarray, readOnly, errors, forceUpdate, formFn, isFormWizard, openFieldLabelModal, currentLocale}) => {

  const clientId = field.client_id;
  let [showError, setShowError] = useState(false);
  let [value, setValue] = useState(formData[clientId] || 0);
  const sliderEle = useRef();
  const bubbleEle = useRef();

  useEffect(()=>{
    if(renderField)updateSliderUi();
  }, [value])

  if(!renderField) return null;

  let inputAttributes = {
    'id': clientId,
    'name': clientId,
    'type':'range',
    'min':0,
    'max':field.max ? field.max : 255,
    'step':'1',
    'disabled':readOnly,
    'required':field.required
  }

  let parentAttributes = {
    'tooltip': field.tooltip
  }

  let labelAttributes = FormHelper.setLabelStyle(field, isFormWizard, parentAttributes);
  
  //FormHelper.setDisabled(field, inputAttributes);
  //FormHelper.checkFieldValidity(field, formData, errors);

  const handleChange = (event) =>{
    const { target } = event;
    const { name } = target;
    const value = (isNaN(target.valueAsNumber) ?  target.value : target.valueAsNumber);
    
    formData[name] = value;
    setValue(value);
    forceUpdate();
  }

  const updateSliderUi = () =>{
    const ratio = ((value / field.max) * 100).toFixed(3);
    sliderEle.current.style.background = 'linear-gradient(to right, #0076BA 0%, #0076BA ' + ratio + '%, #c4bebe ' + ratio + '%, #c4bebe 100%)';

    const newVal = Number(((value - inputAttributes.min) * 100) / (inputAttributes.max - inputAttributes.min));
    bubbleEle.current.style.left = `calc(${newVal}% + (${8 - newVal * 0.15}px))`;
  }

  const setError = (event) => {
    if(field.required){
      const { target:{name, validity:{valueMissing, typeMismatch}} } = event;
      errors[name].invalid = valueMissing;
      errors[name].touched = true;
      if(errors[name].invalid){
        errors.invalid[name] = true;
      }else{
        delete errors.invalid[name]
      }
      setShowError(!showError);
      formFn.refreshFormSubmit();
    }
  };

  const Error = () => {
    if(field.required && (errors[clientId].touched || errors.isSubmitted) && errors[clientId].invalid){
      return(
        <div className="errormsg">
          <div>
            <span className="fas fa-exclamation-triangle m-r-5"/>
            <RequiredMsg {...{field, currentLocale}}/>
          </div>
        </div>
      )
    }
    return null;
  }

  return (
  	<div {...parentAttributes}>
      <div className="flex coldir m-b-20 tooltip">
        <CueTip 
          positionCss={position>1?'top':'bottom'}
          tooltip={field.tooltip}
          currentLocale={currentLocale}
          locale={field.locale?.tooltip}/>
    	  <FieldLabel field={field} 
          isFormWizard={isFormWizard}
          labelAttributes={labelAttributes} 
          currentLocale={currentLocale}
          openFieldLabelModal={openFieldLabelModal}/>
        <div className="flex justspacebetween">
          <span className="badge-2 badge-xxs">{field.min}</span>
          <span className="badge-2 badge-xxs">{field.max}</span>
        </div>
   	    <div className="slidecontainer">
          <output className="bubble" ref={bubbleEle}>{value}</output>
          <input {...inputAttributes} ref={sliderEle}
          onChange={e => handleChange(e)} onBlur={e => {setError(e)}}
          defaultValue={value} className="slider"
          data-tip data-for={`tooltip_${clientId}`}/>
        </div> 	
        <div className="flex justspacebetween">
          <span className="text-muted-2">{field.min_label}</span>
          <span className="text-muted-2">{field.max_label}</span>
        </div> 
        <FieldPoint userRefId={formFn.userRefId} clientId={clientId} 
          point={field.point} currentLocale={currentLocale}  
          negPoint={field.incorrect_point}/>
    	  <Description description={field.description} currentLocale={currentLocale}
          locale={field.locale?.description} />
        <Error/>
 	    </div>
    </div> 
  )
}

export default InputSlider;